import React from "react"
import { MdCheck } from "react-icons/md"
import styles from "./optionCardSelector.module.css"

const normalize = value => value === undefined || value === null ? "" : value.toString()

const OptionCardSelector = ({ options = [], selected = [], onChange, editable = true, single = false, isLocked = () => false, renderIcon, emptyText = "Nenhuma opção disponível" }) => {
    const selectedValues = Array.isArray(selected) ? selected.map(normalize) : []

    const toggleOption = option => {
        if (!editable || isLocked(option)) return
        const optionId = normalize(option.id)
        if (single && selectedValues.includes(optionId)) return
        const nextValues = single
            ? [optionId]
            : selectedValues.includes(optionId)
                ? selectedValues.filter(value => value !== optionId)
                : [...selectedValues, optionId]
        onChange?.(nextValues)
    }

    if (!options.length) return <div className={styles.empty}>{emptyText}</div>

    return (
        <div className={styles.grid}>
            {options.map(option => {
                const active = selectedValues.includes(normalize(option.id))
                const locked = isLocked(option)
                return (
                    <button
                        type="button"
                        key={option.id}
                        className={`${styles.card} ${active ? styles.active : ""} ${locked ? styles.locked : ""}`}
                        onClick={() => toggleOption(option)}
                        aria-pressed={active}
                        disabled={!editable || locked}
                    >
                        <span className={styles.icon}>{renderIcon?.(option)}</span>
                        <span className={styles.content}>
                            <strong>{option.value}</strong>
                            {option.description && <small>{option.description}</small>}
                            {locked && <small>Incluído no plano</small>}
                        </span>
                        <span className={styles.check}>{active && <MdCheck />}</span>
                    </button>
                )
            })}
        </div>
    )
}

export default OptionCardSelector
